import type { ReactNode } from 'react';

export const symbol_flight_class: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M550-440q-28.87 0-49.44-20.56Q480-481.13 480-510v-220q0-28.88 20.56-49.44Q521.13-800 550-800h100q28.88 0 49.44 20.56T720-730v220q0 28.87-20.56 49.44Q678.88-440 650-440H550Zm-10-60h120v-240H540v240ZM372-240q-23 0-42-13.5T305-290L202.06-634.81Q200-640 200-643.5V-770q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v118l105 352h325q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H372Zm-22 120q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h340q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H350Zm190-620h120-120Z"
		/>
	</svg>
);
